import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewOrganizationOrdersContent} from './NewOrganizationOrdersContent';
import reportPayload from './reportPayload';

export const NewOrganizationOrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'New Organization Orders')}
      description={tt(
        'description',
        'Orders from new Clients or Coaches in your organization, this month.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewOrganizationOrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newOrganizationOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(NewOrganizationOrdersReport);
